const statsUpdateInterval = 600000;
const state = {
  percentageAll: "0%",
  songCount: "0",
  fetchedAt: 0,
  updateInterval: statsUpdateInterval
};
const mutations = {
  SET_STATS(state, { stats_percentage_all, stats_song_count }) {
    state.percentageAll = stats_percentage_all;
    state.songCount = stats_song_count;
    state.fetchedAt = Date.now();
  }
};
const actions = {
  setStats(context, stats) {
    context.commit("SET_STATS", stats);
  }
};
const getters = {
  getStats(state) {
    return state;
  },
  getStatsStale(state) {
    const stale = Date.now() - state.fetchedAt > statsUpdateInterval;
    // console.log(stale);
    return stale;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
